import { AuthContextType } from '../contexts/AuthProvider';

// Even though we only have a single account keep this for the future when we integrate MSAL
export function useIsAuthenticated(context: AuthContextType) {
    return context.account;
}
